import {
    ColorNeutralBlack,
    ColorNeutralWhite,
    FontSize12,
    Spacing16,
    Spacing6,
    Spacing8
} from 'autogen/design-tokens/tokens';
import type { BreadcrumbItemViewModel } from 'autogen/swagger/all';
import { Back } from 'autogen/translation-keys/trans-website-shared';
import Icon from 'components/Icon';
import useRequestContext from 'hooks/user/useRequestContext';
import UAEventTracking from 'modules/tracking/UAEventTracking';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { breakpoint, sizes } from 'variables';

export type BackButtonProps = {
    model?: BreadcrumbItemViewModel;
};

const Wrapper = styled.div`
    display: flex;
    height: 50px;
    align-items: center;
    background: ${ColorNeutralWhite};
    padding-left: ${Spacing16};

    ${breakpoint.up(sizes.md)} {
        background: transparent;
    }
`;

const Button = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: ${FontSize12};
    text-transform: uppercase;
    background: transparent;
    border-width: 0 1px 0 0;
    border-color: ${ColorNeutralBlack};
    border-style: solid;
    padding: 0 ${Spacing8} 0 0;
`;

const StyledIcon = styled(Icon)`
    margin-right: ${Spacing6};
`;

export default function BackButton(props: BackButtonProps) {
    const { model } = props;
    const { t } = useTranslation();
    const { supportsNativeBackArrow } = useRequestContext();

    function handleClick(e) {
        e.preventDefault();
        const { referrer } = document;

        UAEventTracking({
            eventCategory: 'breadcrumb',
            eventAction: 'click',
            eventLabel: 'BackButton'
        });

        if (referrer) {
            window.history.back();
        } else if (model?.linkAction) {
            window.location.href = model.linkAction.url;
        }
    }

    if (supportsNativeBackArrow) return null;

    return (
        <Wrapper>
            <Button onClick={handleClick}>
                <StyledIcon type="ChevronLeft" size={16} />
                {t(Back)}
            </Button>
        </Wrapper>
    );
}
